// extracted by mini-css-extract-plugin
export default {"label":"Option_label__emRxy","selected":"Option_selected__hekP+"};